import React from 'react';
import { Link } from 'react-router-dom';
import { FiSmartphone, FiTruck, FiMessageCircle, FiUsers } from 'react-icons/fi';
import Layout from '../components/Layout';
import './AboutPage.css';

function AboutPage({ onLoginClick }) {
  const values = [
    {
      title: 'Accessibility',
      description: 'We serve farmers where they are — on basic phones, in rural areas, in their language.',
      Icon: FiSmartphone,
    },
    {
      title: 'Reliability',
      description: 'Organized transport, tracked trips, and transparent pricing. Your produce gets to market safely.',
      Icon: FiTruck,
    },
    {
      title: 'Simplicity',
      description: 'Straightforward requests. Book transport in minutes, not hours.',
      Icon: FiMessageCircle,
    },
    {
      title: 'Partnership',
      description: 'We grow with farmers. Fair pricing and efficient logistics benefit everyone.',
      Icon: FiUsers,
    },
  ];

  return (
    <Layout onLoginClick={onLoginClick}>
      <div className="about-page">
        <section className="about-hero">
          <div className="about-hero-bg" />
          <div className="about-hero-overlay" />
          <div className="about-hero-content">
            <h1>About FarmFleet</h1>
            <p>Bridging the gap between farm and market</p>
          </div>
        </section>

        <section className="about-story">
          <div className="about-story-inner">
            <div className="about-story-text">
              <h2>Our Story</h2>
              <p>
                FarmFleet was born from a simple observation: farmers often lose time and money 
                getting their produce to market. Transport is fragmented, pricing is unclear, and 
                coordination is difficult — especially in rural areas where connectivity is limited.
              </p>
              <p>
                We built FarmFleet to change that. A digital logistics platform designed for farmers 
                in rural areas. No complex apps, no training, no barriers. 
                Request transport and we handle the rest.
              </p>
            </div>
            <div className="about-story-image">
              <img 
                src="https://upload.wikimedia.org/wikipedia/commons/e/ed/Transport_de_marchandises_par_tricycle_01.jpg" 
                alt="Tricycle transporting goods in Douala, Cameroon" 
              />
            </div>
          </div>
        </section>

        <section className="about-mission-vision">
          <div className="about-mission-vision-inner">
            <div className="about-mission-vision-links">
              <h2>Our Mission & Vision</h2>
              <p>Learn more about what drives us:</p>
              <div className="about-mission-vision-buttons">
                <Link to="/mission" className="about-link-mission">Our Mission</Link>
                <span className="about-link-sep">|</span>
                <Link to="/vision" className="about-link-vision">Our Vision</Link>
              </div>
            </div>
            <div className="about-mission-image">
              <img 
                src="https://images.unsplash.com/photo-1633410195091-bd66114cef5f?w=800" 
                alt="Agents and farmers in the field for due diligence verification" 
              />
            </div>
          </div>
        </section>

        <section className="about-values">
          <div className="about-values-inner">
            <h2>What We Believe</h2>
            <div className="about-values-grid">
              {values.map((value, index) => {
                const Icon = value.Icon;
                return (
                  <div key={index} className="value-card">
                    <span className="value-icon"><Icon aria-hidden /></span>
                    <h3>{value.title}</h3>
                    <p>{value.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="about-cta">
          <div className="about-cta-inner">
            <h2>Join the Fleet</h2>
            <p>Ready to move your produce? Get started today.</p>
            <div className="about-cta-buttons">
              <Link to="/services" className="btn-services">View Services</Link>
              <Link to="/contact" className="btn-contact">Contact Us</Link>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  );
}

export default AboutPage;
